import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const get = axios.get
const post = axios.post
const api = '/api/form-type'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const ListFormType = createAsyncThunk('form-types', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}list`, params), thunkAPI)
)

export const createFormType = createAsyncThunk('form-type-create', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}store`, data), thunkAPI)
)

export const editFormType = createAsyncThunk('form-type-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${api}edit/${id}`), thunkAPI)
)

export const deleteFormType = createAsyncThunk('form-type-del', (id: string, thunkAPI) =>
  handleRequest(get(`${api}destroy/${id}`), thunkAPI)
)

type FormState = {
  record: any
  records: any
  errors: any
}

const initialState: FormState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const formSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListFormType.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createFormType.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = formSlice.actions
export default formSlice.reducer
